import React from "react";
import './style.scss';
import { Card, Carousel } from "legion-ui";

const data = [
  {
    imageURL: "https://legion-dev.vercel.app/images/apple.png",
    alt: "1",
  },
  {
    imageURL: "https://legion-dev.vercel.app/images/apple.png",
    alt: "2",
  },
  {
    imageURL: "https://legion-dev.vercel.app/images/apple.png",
    alt: "3",
  },
];

const CarouselExample2 = () => {
    return (
        <div className="wrapper">
          <Card sx={{ borderRadius: 0 }}>
            <Carousel data={data} ratio={7/3} showIndicator showControl />
          </Card>
        </div>

    )

}

export default CarouselExample2;